import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=61d639b1&scoped=true&"
import script from "./DetailModal.vue?vue&type=script&lang=js&"
export * from "./DetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=61d639b1&prod&lang=scss&scoped=true&"
import style1 from "./DetailModal.vue?vue&type=style&index=1&id=61d639b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d639b1",
  null
  
)

export default component.exports